import {queryOptions} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {WorkoutsDependencies} from '../dependencies';
import type {WorkoutTemplateId} from '../domain/workout-template-id.value-object';
import {keys} from './keys';

export type GetWorkoutTemplateQueryDependencies = Pick<WorkoutsDependencies, 'controllers'>;

export const getWorkoutTemplateQuery = (
  {controllers}: GetWorkoutTemplateQueryDependencies,
  templateId: WorkoutTemplateId,
) =>
  queryOptions({
    queryKey: keys.templates.detail(templateId),
    queryFn: () => controllers.workoutController.getTemplate(templateId).then(unwrap),
  });
